import { Component, Inject, Injector, OnInit } from '@angular/core';
import { TuiDialogContext, TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent, POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';

@Component({
  selector: 'app-tooltippopup',
  templateUrl: './tooltippopup.component.html',
  styleUrls: ['./tooltippopup.component.scss']
})
export class TooltippopupComponent implements OnInit {

  universityAffinityQuestion:any;
  constructor( @Inject(POLYMORPHEUS_CONTEXT)
  private readonly context: TuiDialogContext< any,any>,
  @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
  @Inject(Injector) private readonly injector: Injector,) { 

    this.universityAffinityQuestion=context.data;
  }

  ngOnInit(): void {
  //  console.log("Tooltip data",this.universityAffinityQuestion)

  }

  close()
  {

    this.context.completeWith('');
  }

  getEligibilityPoints(eligibilitydata:string)
  {

    let eligibility=eligibilitydata.split('_@_');
    return eligibility;
  }

  getTersandConditionPoints(tersandConditionData:string)
  {

    let eligibility=tersandConditionData.split('_@_');
    return eligibility;
  }
  firstLetterUpper(strOption) {
    var str = strOption.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) { return c.toUpperCase() });
    return str;
  }

}
